module.exports = __webpack_public_path__ + "public/img/front.34aa6b3b.png";